/* Aerotex product library: same layout and behaviour as the swatch page, for every product category */
(function () {
  'use strict';
  var root = document.querySelector('[data-ax-library]');
  if (!root) return;
  var RAW = [];
  try { RAW = JSON.parse(root.querySelector('[data-ax-lib-data]').textContent); } catch (e) { return; }

  var $ = function (s) { return root.querySelector(s); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var norm = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); };
  var SWATCH = ['aerotex-fabric', 'aerotex-premium-fabric', 'luxaire-fabric-duralite', 'aircraft-leather', 'aircraft-vinyl', 'coin-dot-flooring', 'wall-blanket-insulation', 'boltatron-4335', 'kydex-100', 'kydex-t'];

  /* ---------- Products (one tile per product, even if it sits in two menu groups) ---------- */
  var P = [], seen = {};
  RAW.forEach(function (p) {
    if (seen[p.h]) { var o = seen[p.h]; if (o.types.indexOf(p.y) < 0) o.types.push(p.y); o.hay += ' ' + norm(p.y); return; }
    p.types = [p.y];
    p.hay = norm([p.t, p.c, p.y, p.s].concat(p.v.map(function (v) { return v.t + ' ' + v.s; })).join(' '));
    seen[p.h] = p; P.push(p);
  });
  var CATS = [], TYPES = [];
  P.forEach(function (p) { if (CATS.indexOf(p.c) < 0) CATS.push(p.c); p.types.forEach(function (t) { if (TYPES.indexOf(t) < 0) TYPES.push(t); }); });
  var groupBy = CATS.length > 1 ? 'c' : 'y';

  /* ---------- Quote List (same storage + item format as the product pages) ---------- */
  var KEY = 'aerotex-quote-draft';
  var read = function () { try { return JSON.parse(localStorage.getItem(KEY) || '[]').filter(function (x) { return x && typeof x.key === 'string'; }); } catch (e) { return []; } };
  var last = null, toastTimer;
  function toast(t) { var el = document.querySelector('[data-quote-toast]'); if (!el) return; el.textContent = t; el.hidden = false; clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.hidden = true; }, 3500); }
  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); last = items; } catch (e) { toast('Your browser could not save the Quote List. Keep this page open.'); return; }
    document.querySelectorAll('[data-quote-count]').forEach(function (e) { e.textContent = items.length; });
  }
  document.addEventListener('submit', function (e) {
    if (last && e.target.closest && e.target.closest('.rd-customer-form')) setTimeout(function () { var cur = read(); last.forEach(function (it) { if (!cur.some(function (c) { return c.key === it.key; })) cur.push(it); }); write(cur); }, 0);
  }, true);
  var keyOf = function (p, v) { return p.h + ':' + v.id; };
  var inList = function (p, v) { var k = keyOf(p, v); return read().some(function (i) { return i.key === k; }); };
  var anyInList = function (p) { var keys = read().map(function (i) { return i.key; }); return p.v.some(function (v) { return keys.indexOf(keyOf(p, v)) > -1; }); };
  function toggle(p, v) {
    var items = read(), k = keyOf(p, v), had = items.some(function (i) { return i.key === k; });
    var label = p.t + (p.vc > 1 ? ' (' + v.t + ')' : '');
    if (had) { items = items.filter(function (i) { return i.key !== k; }); toast('Removed ' + label + ' from your Quote List'); }
    else { items.push({ key: k, handle: p.h, name: p.t, variant: v.id, variantTitle: v.t, sku: v.s || '', image: v.i || p.i, qty: 1, notes: '', url: p.u + (p.vc > 1 ? '?variant=' + v.id : '') }); toast('Added ' + label + ' to your Quote List'); }
    write(items); sync();
  }

  /* ---------- State, filter bar and URL ---------- */
  var params = new URLSearchParams(location.search);
  var state = { q: params.get('q') || '', c: params.get('category') || '', y: params.get('type') || '' };
  var qIn = document.querySelector('[data-ax-libbar-q]') || document.createElement('input');
  var barC = document.querySelector('[data-ax-libbar-c]'), barY = document.querySelector('[data-ax-libbar-y]'), barCount = document.querySelector('[data-ax-libbar-count]');
  qIn.value = state.q;
  if (barC) { if (CATS.length < 2) barC.closest('.ax-shop__field').hidden = true; CATS.forEach(function (c) { var o = document.createElement('option'); o.value = c; o.textContent = c; barC.appendChild(o); }); }
  if (barY) TYPES.forEach(function (t) { var o = document.createElement('option'); o.value = t; o.textContent = t; barY.appendChild(o); });
  if (CATS.length < 2) { var cg = $('[data-ax-lib-catgroup]'); if (cg) cg.hidden = true; }
  function saveUrl() {
    var u = new URL(location.href);
    [['q', state.q], ['category', state.c], ['type', state.y]].forEach(function (p) { if (p[1]) u.searchParams.set(p[0], p[1]); else u.searchParams.delete(p[0]); });
    history.replaceState(null, '', u);
  }

  /* ---------- Render tiles in brochure-style sections ---------- */
  var results = $('[data-ax-sw-results]'), groups = groupBy === 'c' ? CATS : TYPES, html = '';
  groups.forEach(function (g, gi) {
    var list = P.filter(function (p) { return groupBy === 'c' ? p.c === g : p.types[0] === g; });
    if (!list.length) return;
    var cols = list.length <= 4 ? 4 : 6;
    html += '<div class="ax-sw__mat" data-ax-sw-mat="' + gi + '"><div class="ax-sw__mat-h"><h2>' + esc(g) + '</h2><p><span data-ax-sw-matcount></span></p></div><ul class="ax-sw__grid ax-sw__grid--' + cols + '">';
    list.forEach(function (p) {
      var i = P.indexOf(p);
      var sub = p.vc > 1 ? p.vc + ' options' : (p.s || (groupBy === 'c' ? p.types[0] : ''));
      html += '<li class="ax-sw__card" data-ax-lib-i="' + i + '">' +
        '<button type="button" class="ax-sw__img" data-ax-lib-open="' + i + '" aria-label="Enlarge ' + esc(p.t) + '">' +
        (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="500" height="500">' : '<span class="ax-sw__noimg">Photo on request</span>') + '</button>' +
        '<div class="ax-lib__cap"><strong>' + esc(p.t) + '</strong>' + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</div>' +
        '<button type="button" class="ax-sw__add" data-ax-lib-add="' + i + '">+</button></li>';
    });
    html += '</ul></div>';
  });
  results.innerHTML = html;
  var cards = [].slice.call(results.querySelectorAll('[data-ax-lib-i]'));
  var mats = [].slice.call(results.querySelectorAll('[data-ax-sw-mat]'));

  function matches(p, ignore) {
    if (ignore !== 'c' && state.c && p.c !== state.c) return false;
    if (ignore !== 'y' && state.y && p.types.indexOf(state.y) < 0) return false;
    var toks = norm(state.q).split(' ').filter(Boolean);
    for (var i = 0; i < toks.length; i++) if (p.hay.indexOf(toks[i]) === -1) return false;
    return true;
  }
  var catBox = $('[data-ax-lib-cats]'), typeBox = $('[data-ax-lib-types]');
  function chip(kind, value, text, n, on) { return '<button type="button" class="ax-sw__chip' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-ax-lib-' + kind + '="' + esc(value) + '"' + (n || on ? '' : ' disabled') + '>' + esc(text) + ' <span>' + n + '</span></button>'; }
  function renderChips() {
    var h = chip('c', '', 'All', P.filter(function (p) { return matches(p, 'c'); }).length, !state.c);
    CATS.forEach(function (c) { h += chip('c', c, c, P.filter(function (p) { return p.c === c && matches(p, 'c'); }).length, state.c === c); });
    catBox.innerHTML = h;
    var t = chip('y', '', 'All', P.filter(function (p) { return matches(p, 'y'); }).length, !state.y);
    TYPES.forEach(function (y) { var n = P.filter(function (p) { return p.types.indexOf(y) > -1 && matches(p, 'y'); }).length; if (n || state.y === y) t += chip('y', y, y, n, state.y === y); });
    typeBox.innerHTML = t;
    if (barC) { [].forEach.call(barC.options, function (o) { var n = P.filter(function (p) { return (!o.value || p.c === o.value) && matches(p, 'c'); }).length; o.textContent = (o.value || 'All categories') + ' (' + n + ')'; }); barC.value = state.c; }
    if (barY) { [].forEach.call(barY.options, function (o) { var n = P.filter(function (p) { return (!o.value || p.types.indexOf(o.value) > -1) && matches(p, 'y'); }).length; o.textContent = (o.value || 'All types') + ' (' + n + ')'; o.hidden = !!o.value && !n && state.y !== o.value; }); barY.value = state.y; }
  }
  var countEl = $('[data-ax-sw-count]'), resetEl = $('[data-ax-sw-reset]'), emptyEl = $('[data-ax-sw-empty]');
  function apply() {
    var shown = 0;
    cards.forEach(function (li) { var ok = matches(P[li.dataset.axLibI]); li.hidden = !ok; if (ok) shown++; });
    mats.forEach(function (m) { var n = m.querySelectorAll('[data-ax-lib-i]:not([hidden])').length; m.hidden = !n; m.querySelector('[data-ax-sw-matcount]').textContent = n + (n === 1 ? ' product' : ' products'); });
    countEl.textContent = (shown === P.length ? 'Showing all ' : 'Showing ' + shown + ' of ') + P.length + ' products';
    resetEl.hidden = !(state.q || state.c || state.y);
    emptyEl.hidden = !!shown;
    if (barCount) barCount.textContent = countEl.textContent;
  }
  function sync() {
    cards.forEach(function (li) {
      var p = P[li.dataset.axLibI], on = anyInList(p), b = li.querySelector('[data-ax-lib-add]');
      b.classList.toggle('is-added', on); li.classList.toggle('is-added', on);
      b.textContent = on ? '✓' : '+';
      b.setAttribute('aria-label', on ? p.t + ' is in your Quote List' : 'Add ' + p.t + ' to your Quote List');
      b.title = on ? 'In your Quote List' : (p.vc > 1 ? 'Choose an option and add to Quote List' : 'Add to Quote List');
    });
    if (current) setAdd();
  }
  function update() { renderChips(); apply(); saveUrl(); }

  qIn.addEventListener('input', function () { state.q = qIn.value.trim(); update(); });
  catBox.addEventListener('click', function (e) { var b = e.target.closest('[data-ax-lib-c]'); if (!b) return; state.c = b.dataset.axLibC; update(); });
  typeBox.addEventListener('click', function (e) { var b = e.target.closest('[data-ax-lib-y]'); if (!b) return; state.y = b.dataset.axLibY; update(); });
  var jump = function () { var r = results.getBoundingClientRect(); if (r.top > window.innerHeight * 0.6 || r.bottom < 0) results.scrollIntoView({ behavior: 'smooth' }); };
  if (barC) barC.addEventListener('change', function () { state.c = barC.value; update(); jump(); });
  if (barY) barY.addEventListener('change', function () { state.y = barY.value; update(); jump(); });
  qIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); jump(); } });
  resetEl.addEventListener('click', function () { state = { q: '', c: '', y: '' }; qIn.value = ''; update(); });

  /* ---------- Enlarge dialog with option picker ---------- */
  var dlg = $('[data-ax-sw-dialog]'), dImg = $('[data-ax-sw-d-img]'), dAdd = $('[data-ax-sw-d-add]'), vWrap = $('[data-ax-lib-vwrap]'), vSel = $('[data-ax-lib-variant]'), swLink = $('[data-ax-lib-swatch]'), current = null;
  function curVariant() { return current.v.filter(function (v) { return String(v.id) === vSel.value; })[0] || current.v[0]; }
  function setAdd() { var on = inList(current, curVariant()); dAdd.classList.toggle('is-added', on); dAdd.textContent = on ? '✓ In Quote List' : 'Add to Quote List'; }
  function setImg() { var v = curVariant(); dImg.src = (v && v.i) || current.l || current.i; $('[data-ax-sw-d-view]').href = current.u + (current.vc > 1 ? '?variant=' + v.id : ''); }
  function open(p) {
    current = p;
    vSel.innerHTML = p.v.map(function (v) { return '<option value="' + v.id + '">' + esc(v.t) + (v.s ? ' · ' + esc(v.s) : '') + '</option>'; }).join('');
    vWrap.hidden = p.vc < 2;
    dImg.alt = p.t;
    $('[data-ax-sw-d-title]').textContent = p.t;
    $('[data-ax-sw-d-mat]').textContent = p.c + (p.types[0] && p.types[0] !== p.t ? ' · ' + p.types[0] : '') + (p.vc < 2 && p.s ? ' · ' + p.s : '');
    swLink.hidden = SWATCH.indexOf(p.h) < 0;
    swLink.href = '/pages/swatches?material=' + p.h;
    setImg(); setAdd();
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }
  vSel.addEventListener('change', function () { setImg(); setAdd(); });
  results.addEventListener('click', function (e) {
    var o = e.target.closest('[data-ax-lib-open]'); if (o) { open(P[o.dataset.axLibOpen]); return; }
    var a = e.target.closest('[data-ax-lib-add]'); if (!a) return;
    var p = P[a.dataset.axLibAdd];
    if (p.vc > 1) open(p); else toggle(p, p.v[0]);
  });
  dAdd.addEventListener('click', function () { if (current) toggle(current, curVariant()); });
  $('[data-ax-sw-close]').addEventListener('click', function () { dlg.close(); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  dlg.addEventListener('close', function () { current = null; });

  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
  update(); sync();
})();
